export class TopMenuBreadCrumb {
  organizationName: string;
  subscriptionName: string;
  projectTypeName: string;
  subscriptionServiceType: string;
  projectName: string;

}
